import { render } from "./MathP.vue?vue&type=template&id=adb6e1e2"
import script from "./MathP.vue?vue&type=script&lang=js"
export * from "./MathP.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__